/** Satu tempat pembulatan tampilan. Indeks disimpan & dibanding desimal. */
export const round1 = (n: number) => Math.round(n * 10) / 10;

/**
 * "Semester 2 — Monitoring 1" → "Sem 2".
 *
 * Nama lengkapnya ~93px pada 9px, sementara satu slot sumbu-X hanya ~97px
 * saat enam periode tampil — label akan saling menimpa. Fase periodenya sudah
 * terbaca di pemilih periode dan di judul kartu.
 */
export const shortPeriod = (name: string) => {
  const match = /Semester\s+(\d+)/i.exec(name);
  return match ? `Sem ${match[1]}` : name;
};
